var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { size: "small", bordered: false } },
    [
      _c(
        "div",
        { staticClass: "page-header-index-wide" },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c("a-col", { attrs: { sm: 6, md: 6, xl: 6 } }, [
                _c("div", [
                  _vm._v(
                    "總人數/座位總數:" +
                      _vm._s(_vm.totalPerson) +
                      "/" +
                      _vm._s(_vm.totalSeats) +
                      ",未選座位人數:" +
                      _vm._s(_vm.noAssignPersons)
                  )
                ])
              ]),
              _c(
                "a-col",
                { attrs: { justify: "end", sm: 18, md: 18, xl: 18 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-operator",
                      staticStyle: { float: "right" }
                    },
                    [
                      _c("a-button", { on: { click: _vm.handleAutoRank } }, [
                        _vm._v("一鍵排位")
                      ]),
                      _c("a-button", { on: { click: _vm.handleOneClear } }, [
                        _vm._v("一鍵清除")
                      ]),
                      _c("a-button", { on: { click: _vm.handleManualRank } }, [
                        _vm._v("手動選座")
                      ]),
                      _c("a-button", { on: { click: _vm.handleCancelRank } }, [
                        _vm._v("取消選座")
                      ]),
                      _c("a-button", { on: { click: _vm.handleOccupyRank } }, [
                        _vm._v("佔位")
                      ]),
                      _c("a-button", { on: { click: _vm.handleLockRank } }, [
                        _vm._v("鎖定")
                      ]),
                      _c("a-button", { on: { click: _vm.handleUnlockRank } }, [
                        _vm._v("解鎖")
                      ]),
                      _c("a-button", { on: { click: _vm.handleSwapRank } }, [
                        _vm._v("互換座位")
                      ]),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { icon: "download" },
                          on: { click: _vm.ExportXls }
                        },
                        [_vm._v("导出")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-tabs",
                {
                  attrs: { "hide-add": "", "active-key": _vm.activeKey },
                  on: { change: _vm.handleClickTab },
                  scopedSlots: _vm._u([
                    {
                      key: "tabBarExtraContent",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c("ImageView", {
                                staticClass: "imgOfKinds",
                                attrs: { imgUrl: _vm.sysfloorData.allfiles }
                              }),
                              _vm.from === "VenueList"
                                ? _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.handleEditVenueInfo }
                                    },
                                    [
                                      _vm._v(
                                        "\n              編輯場館\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "a-dropdown",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "overlay",
                                      fn: function() {
                                        return [
                                          _c(
                                            "a-menu",
                                            [
                                              _c(
                                                "a-menu-item",
                                                {
                                                  key: "1",
                                                  on: {
                                                    click:
                                                      _vm.handleAddFloorInfo
                                                  }
                                                },
                                                [_vm._v("新增樓層")]
                                              ),
                                              _c(
                                                "a-menu-item",
                                                {
                                                  key: "2",
                                                  on: {
                                                    click:
                                                      _vm.handleEditFloorInfo
                                                  }
                                                },
                                                [_vm._v("修改樓層")]
                                              ),
                                              _c(
                                                "a-menu-item",
                                                {
                                                  key: "3",
                                                  on: {
                                                    click:
                                                      _vm.handleDeleteFloorInfo
                                                  }
                                                },
                                                [_vm._v("刪除樓層")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "a-button",
                                    [
                                      _vm._v(
                                        "\n                設定樓層\n                "
                                      ),
                                      _c("a-icon", {
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: { type: "down" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                _vm._l(_vm.FloorAreaList, function(pane) {
                  return _c(
                    "a-tab-pane",
                    {
                      key: pane.sysfloorid,
                      attrs: { tab: pane.floorname, closable: pane.closable }
                    },
                    [
                      _c(
                        "div",
                        { style: { marginTop: "5px" } },
                        [
                          _c(
                            "a-radio-group",
                            {
                              attrs: {
                                defaultValue: _vm.active,
                                "button-style": "solid"
                              },
                              on: { change: _vm.handleRadioChange },
                              model: {
                                value: _vm.active,
                                callback: function($$v) {
                                  _vm.active = $$v
                                },
                                expression: "active"
                              }
                            },
                            _vm._l(pane.children, function(item) {
                              return _c(
                                "a-radio-button",
                                {
                                  key: item.sysareaid,
                                  attrs: {
                                    "button-style": "solid",
                                    value: item.sysareaid
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.areaname) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          ),
                          _c("a-divider", { attrs: { type: "vertical" } }),
                          _c(
                            "div",
                            {
                              staticClass: "current-settings",
                              staticStyle: { "margin-left": "100px" }
                            },
                            [_vm._v("當前設置的座位狀態為:")]
                          ),
                          _c(
                            "a-radio-group",
                            {
                              attrs: { "button-style": "solid" },
                              on: { change: _vm.handleRadioStatusChange },
                              model: {
                                value: _vm.status,
                                callback: function($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status"
                              }
                            },
                            [
                              _c(
                                "a-radio-button",
                                {
                                  key: 0,
                                  attrs: { "button-style": "solid", value: 0 }
                                },
                                [
                                  _vm._v(
                                    "\n                可用\n              "
                                  )
                                ]
                              ),
                              _c(
                                "a-radio-button",
                                {
                                  key: 1,
                                  attrs: { "button-style": "solid", value: 1 }
                                },
                                [
                                  _vm._v(
                                    "\n                不可用\n              "
                                  )
                                ]
                              ),
                              _c(
                                "a-radio-button",
                                {
                                  key: 2,
                                  attrs: { "button-style": "solid", value: 2 }
                                },
                                [
                                  _vm._v(
                                    "\n                不可见\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "a-dropdown",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "overlay",
                                        fn: function() {
                                          return [
                                            _c(
                                              "a-menu",
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "1",
                                                    on: {
                                                      click:
                                                        _vm.handleAddAreaInfo
                                                    }
                                                  },
                                                  [_vm._v("新增區域")]
                                                ),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "2",
                                                    on: {
                                                      click:
                                                        _vm.handleEditAreaInfo
                                                    }
                                                  },
                                                  [_vm._v("修改區域")]
                                                ),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "3",
                                                    on: {
                                                      click:
                                                        _vm.handleDeleteAreaInfo
                                                    }
                                                  },
                                                  [_vm._v("刪除區域")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c(
                                    "a-button",
                                    [
                                      _vm._v(
                                        "\n                  設定區域\n                  "
                                      ),
                                      _c("a-icon", {
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: { type: "down" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "main" }, [
                        _c("div", { staticClass: "main-content" }, [
                          _c("div", { staticClass: "select-hbody" }, [
                            _c(
                              "div",
                              { staticClass: "tdbody-line" },
                              [
                                _vm._l(_vm.maxColQty, function(item, pk) {
                                  return _c(
                                    "div",
                                    {
                                      key: pk,
                                      staticClass: "colno",
                                      on: {
                                        contextmenu: function($event) {
                                          return _vm.showMenuCol(pk + 1, "col")
                                        },
                                        click: function($event) {
                                          return _vm.clickData(
                                            "rows",
                                            _vm.maxRowQty,
                                            pk
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(pk + 1) + "列")]
                                  )
                                }),
                                _c(
                                  "div",
                                  { key: _vm.maxColQty },
                                  [
                                    _c(
                                      "a-button",
                                      { on: { click: _vm.handleAddCol } },
                                      [
                                        _vm._v(
                                          "\n                      新增列\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "tdbody-coln" },
                            [
                              _vm._l(_vm.maxRowQty, function(item, hk) {
                                return _c(
                                  "div",
                                  {
                                    key: hk,
                                    staticClass: "rowno",
                                    on: {
                                      contextmenu: function($event) {
                                        return _vm.showMenuRow(hk + 1, "row")
                                      },
                                      click: function($event) {
                                        return _vm.clickData(
                                          "cols",
                                          hk,
                                          _vm.maxColQty
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(hk + 1) + "排")]
                                )
                              }),
                              _c(
                                "div",
                                {
                                  key: _vm.maxRowQty,
                                  on: { click: _vm.handleAddRow }
                                },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        width: "60px",
                                        "text-align": "center"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    新增排\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "select-area",
                              on: {
                                mousedown: _vm.down,
                                mousemove: _vm.move,
                                mouseup: _vm.upan
                              }
                            },
                            [
                              _c("div", {
                                ref: "movable",
                                refInFor: true,
                                staticClass: "move",
                                style: _vm.myStyle
                              }),
                              _vm._l(_vm.subset, function(item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "list" },
                                  _vm._l(item, function(val, pk) {
                                    return _c(
                                      "div",
                                      { key: pk, staticClass: "oplist" },
                                      [
                                        val.status === "0"
                                          ? _c("div", {
                                              ref: "seats_" + pane.sysfloorid,
                                              refInFor: true,
                                              staticClass: "item ",
                                              class:
                                                _vm.selected.indexOf(
                                                  pk + 1 + index * _vm.maxColQty
                                                ) > -1
                                                  ? "selected"
                                                  : "",
                                              style: {
                                                border:
                                                  _vm.bordersize +
                                                  val.sgroupcolor
                                              },
                                              attrs: { id: val.sysseatid },
                                              on: {
                                                contextmenu: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.showMenuSignal(
                                                    val.sysseatid
                                                  )
                                                }
                                              }
                                            })
                                          : val.status === "1" ||
                                            val.status === "2"
                                          ? _c(
                                              "div",
                                              {
                                                ref: "seats_" + pane.sysfloorid,
                                                refInFor: true,
                                                staticClass: "emptyseat",
                                                class:
                                                  _vm.selected.indexOf(
                                                    pk +
                                                      1 +
                                                      index * _vm.maxColQty
                                                  ) > -1
                                                    ? "selected"
                                                    : "",
                                                attrs: { id: val.sysseatid },
                                                on: {
                                                  contextmenu: function(
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                    return _vm.showMenuSignal(
                                                      val.sysseatid
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(val.remark))]
                                            )
                                          : val.status === "3"
                                          ? _c(
                                              "div",
                                              {
                                                ref: "seats_" + pane.sysfloorid,
                                                refInFor: true,
                                                staticClass: "item green",
                                                style: {
                                                  border:
                                                    _vm.bordersize +
                                                    val.sgroupcolor
                                                },
                                                attrs: { id: val.sysseatid },
                                                on: {
                                                  contextmenu: function(
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                    return _vm.showMenuSignal(
                                                      val.sysseatid
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(val.pname) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : val.status === "4"
                                          ? _c(
                                              "div",
                                              {
                                                ref: "seats_" + pane.sysfloorid,
                                                refInFor: true,
                                                staticClass: "item yellow",
                                                class:
                                                  _vm.selected.indexOf(
                                                    pk +
                                                      1 +
                                                      index * _vm.maxColQty
                                                  ) > -1
                                                    ? "selected"
                                                    : "",
                                                style: {
                                                  border:
                                                    _vm.bordersize +
                                                    val.sgroupcolor
                                                },
                                                attrs: { id: val.sysseatid },
                                                on: {
                                                  contextmenu: function(
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                    return _vm.showMenuSignal(
                                                      val.sysseatid
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(val.pname))]
                                            )
                                          : _c("div", {
                                              ref: "seats_" + pane.sysfloorid,
                                              refInFor: true,
                                              staticClass: "item red",
                                              class:
                                                _vm.selected.indexOf(
                                                  pk + 1 + index * _vm.maxColQty
                                                ) > -1
                                                  ? "selected"
                                                  : "",
                                              style: {
                                                border:
                                                  _vm.bordersize +
                                                  val.sgroupcolor
                                              },
                                              attrs: { id: val.sysseatid },
                                              on: {
                                                contextmenu: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.showMenuSignal(
                                                    val.sysseatid
                                                  )
                                                }
                                              }
                                            })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              })
                            ],
                            2
                          ),
                          _c(
                            "div",
                            [
                              _c("vue-context-menu", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  contextMenuData: _vm.contextMenuDataRow
                                },
                                on: { addrow: _vm.addrow, delrow: _vm.delrow }
                              }),
                              _c("vue-context-menu", {
                                attrs: {
                                  contextMenuData: _vm.contextMenuDataCol
                                },
                                on: { addcol: _vm.addcol, delcol: _vm.delcol }
                              }),
                              _c("vue-context-menu", {
                                attrs: {
                                  contextMenuData: _vm.contextMenuDataSignal
                                },
                                on: {
                                  ManualRank: _vm.handleManualRank,
                                  UnlockRank: _vm.handleUnlockRank,
                                  LockRank: _vm.handleLockRank,
                                  OccupyRank: _vm.handleOccupyRank,
                                  CancelRank: _vm.handleCancelRank
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c("PersonSelectedModal", { ref: "personSelectedModal" })
        ],
        1
      ),
      _c("person-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } }),
      _c("ActivityModal", { ref: "modalFormActivity" }),
      _c(
        "div",
        [
          _c("VenueInfoModal", {
            ref: "venueInfoModal",
            on: { ok: _vm.refreshVenueName }
          }),
          _c("FloorModal", {
            ref: "floorModal",
            attrs: { from: _vm.from },
            on: { ok: _vm.loadData }
          }),
          _c("AreaModal", {
            ref: "areaModal",
            attrs: { from: _vm.from },
            on: { ok: _vm.loadData }
          })
        ],
        1
      ),
      _c(
        "j-modal",
        {
          ref: "personModal",
          attrs: {
            title: "選擇排位人員",
            width: "40%",
            visible: _vm.personModalVisible,
            okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
            cancelText: "关闭"
          },
          on: { ok: _vm.handlePersonFormOk, cancel: _vm.handlePersonFormCancel }
        },
        [
          [
            _c(
              "div",
              [
                _c("a-row", [
                  _c("span", [
                    _vm._v(
                      "座位信息：" +
                        _vm._s(
                          _vm.selectedseats
                            .map(function(item) {
                              return item.seatname
                            })
                            .join(",")
                        )
                    )
                  ])
                ]),
                _c(
                  "a-row",
                  [
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          allowClear: "",
                          placeholder: "選擇排位人員",
                          showSearch: "",
                          "filter-option": _vm.filterOption
                        },
                        on: {
                          popupScroll: _vm.handlePopupScroll,
                          search: _vm.handleSearch
                        },
                        model: {
                          value: _vm.selectedperson,
                          callback: function($$v) {
                            _vm.selectedperson = $$v
                          },
                          expression: "selectedperson"
                        }
                      },
                      _vm._l(_vm.personNoAssign, function(frontSelect) {
                        return _c(
                          "a-select-option",
                          { key: frontSelect.value },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(frontSelect.label) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      ),
      _c(
        "j-modal",
        {
          ref: "assignrule",
          attrs: {
            title: "排座規則",
            width: "40%",
            visible: _vm.assignruleModalVisible,
            okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
            cancelText: "关闭"
          },
          on: {
            ok: _vm.handleAssignruleFormOk,
            cancel: _vm.handleAssignruleFormCancel
          }
        },
        [
          [
            _c(
              "div",
              [
                _c(
                  "a-row",
                  [
                    _c(
                      "a-radio-group",
                      {
                        model: {
                          value: _vm.assign_rule,
                          callback: function($$v) {
                            _vm.assign_rule = $$v
                          },
                          expression: "assign_rule"
                        }
                      },
                      _vm._l(_vm.assignruleList, function(item) {
                        return _c(
                          "a-radio",
                          {
                            key: item.key,
                            style: _vm.radioStyle,
                            attrs: { value: item.key }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }